import { useSelector } from "react-redux";
import { RootState } from "../store";

export const useLoggedIn = () => {
  const user = useSelector((state: RootState) => state.user);
  return Boolean(user.id);
};
